import React, { useState, useEffect } from "react";
import { Typography, Table, Button, Checkbox } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { generateBtlFile, generateKerenFile } from "../../../api/server";
import moment from "moment";
import Currency from "../../../components/tables/Currency";
import { useSelector } from "react-redux";
import { openURL } from "../../../components/util/helpers";
import { useClientCategories } from "../../../hooks";
import { useDispatch } from "react-redux";
import { notifyError } from "../../notifications/notificationsSlice";
import { CheckCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

const ProspectusesTable = (props) => {
  const { prospectuses, createFileMode, onHide } = props;
  const dispatch = useDispatch();

  const intl = useIntl();
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [uploadFtp, setUploadFtp] = useState(true);
  const activeYear = useSelector((state) => state.prospectuses.activeYear);
  const activeMonth = useSelector((state) => state.prospectuses.activeMonth);
  const activeBranch = useSelector((state) => state.prospectuses.activeBranch);
  const clientCategories = useClientCategories();
  console.log(prospectuses);
  console.log(data);

  useEffect(() => {
    const clientCategory = clientCategories.filter(
      (item) => item.name === "הקרן לנפגעי שואה"
    )[0];
    if (clientCategory) {
      const items = prospectuses.filter((item) =>
        createFileMode === "btl"
          ? item["client"]["social_security"] === true &&
            item["canceled"] !== true &&
            item["type"] !== "refund"
          : item["client"]["category_id"] === clientCategory.id &&
            item["canceled"] !== true &&
            item["type"] !== "refund"
      );
      setData(items);
    }
  }, [prospectuses, clientCategories, createFileMode]);

  let { branchId } = useParams();
  const branch_id = branchId ? branchId : activeBranch;

  const onCreate = async () => {
    const params = {
      year: +activeYear,
      month: +activeMonth,
      prospectuses: selectedRowKeys,
      upload_ftp: uploadFtp,
    };
    try {
      const action =
        createFileMode === "btl"
          ? await generateBtlFile(params, branch_id)
          : await generateKerenFile(params, branch_id);
      const { file_url } = action;
      openURL(file_url);
    } catch (e) {
      dispatch(
        notifyError({ title: "generate_accounting", message: e.error || e })
      );
    }
    onHide();
  };

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.prospectuses.prospectus_id",
      }),
      width: "200px",
      render(text, record) {
        return <Text>{record["serial_number"]}</Text>;
      },
    },

    {
      title: intl.formatMessage({
        id: "app.prospectuses.client_id",
      }),
      width: "200px",
      render(text, record) {
        return <Text>{record["client"]["name"]}</Text>;
      },
    },

    {
      title: intl.formatMessage({
        id: "app.prospectuses.prospectus_type",
      }),
      width: "100px",
      render(text, record) {
        return (
          <Text>
            {record.supporting_community
              ? intl.formatMessage({
                  id: "app.prospectuses.supporting_community",
                })
              : record.day_center
              ? intl.formatMessage({
                  id: "app.prospectuses.day_center",
                })
              : intl.formatMessage({
                  id: "app.prospectuses.home_care",
                })}
          </Text>
        );
      },
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.date",
      }),
      width: "200px",
      render(text, record) {
        const date = moment().set({
          year: record["year"],
          month: record["month"] - 1,
        });
        const dateFormat = "MM/YYYY";
        return <Text>{date.format(dateFormat)}</Text>;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.charged_amount",
      }),
      width: "200px",
      render(text, record) {
        return <Currency text={record["charged_amount"]} />;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.refund_amount",
      }),
      width: "200px",
      render(text, record) {
        return <Currency text={record["refund_amount"]} />;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.paid_amount",
      }),
      width: "200px",
      render(text, record) {
        return <Currency text={record["paid_amount"]} />;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.reclaimed_amount",
      }),
      width: "200px",
      render(text, record) {
        return <Currency text={record["reclaimed_amount"]} />;
      },
    },

    {
      title: intl.formatMessage({
        id: "app.prospectuses.balance",
      }),
      width: "200px",
      render(text, record) {
        return <Currency text={record["balance"]} />;
      },
    },
  ];

  const onSelectChange = (selected) => {
    setSelectedRowKeys(selected);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div>
      <Table
        bordered
        className="scheduling-approval"
        pagination={false}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        scroll={{ y: window.innerHeight - 210 }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          padding: "20px",
        }}
      >
        <Button
          type="primary"
          onClick={onCreate}
          disabled={!selectedRowKeys || selectedRowKeys.length === 0}
        >
          {intl.formatMessage({
            id:
              createFileMode === "btl"
                ? "app.prospectuses.createBtlFileAction"
                : "app.prospectuses.createKerenFileAction",
          })}
        </Button>
        <Checkbox
          checked={uploadFtp}
          onChange={(e) => setUploadFtp(e.target.checked)}
          style={{ position: "absolute", right: "40px" }}
        >
          {intl.formatMessage({ id: "app.prospectuses.uploadFtp" })}
        </Checkbox>
      </div>
    </div>
  );
};

export default ProspectusesTable;
